import type { Translation } from './en';

const de: Translation = {
  app: {
    name: 'Dishly',
  },
  common: {
    cancel: 'Abbrechen',
    close: 'Schließen',
    save: 'Speichern',
    loading: 'Wird geladen …',
    retry: 'Erneut versuchen',
    create: 'Erstellen',
    undo: 'Rückgängig',
    more: 'Weitere Optionen',
  },
  nav: {
    home: 'Dishly-Startseite',
    add: 'Hinzufügen',
    addRecipe: 'Rezept hinzufügen',
    shoppingList: 'Einkaufsliste',
    lists: 'Meine Listen',
    myRecipes: 'Meine Rezepte',
    account: 'Konto',
    logIn: 'Anmelden / Registrieren',
    logOut: 'Abmelden',
    themeDark: 'Zum dunklen Design wechseln',
    themeLight: 'Zum hellen Design wechseln',
    language: 'Sprache',
    userMenu: 'Kontomenü',
    offline: 'Offline',
    offlineHint: 'Du bist offline. Heruntergeladene Rezepte und deine Listen funktionieren weiterhin.',
  },
  home: {
    title: 'Rezepte',
    count_one: '{{count}} Rezept',
    count_other: '{{count}} Rezepte',
    tags: 'Schlagwörter',
    showAll: 'Alle anzeigen',
    sortLabel: 'Sortieren nach',
    sort: {
      newest: 'Neueste',
      rating: 'Bestbewertet',
      quickest: 'Schnellste',
      name: 'A–Z',
    },
    viewGrid: 'Rasteransicht',
    viewList: 'Listenansicht',
    empty: 'Noch keine Rezepte.',
    emptyHint: 'Teile als Erste:r ein Rezept!',
    noMatches: 'Kein Rezept passt zu all diesen Schlagwörtern.',
    noMatchesHint: 'Entferne ein Schlagwort.',
    offlineEmpty: 'Du bist offline und es wurden noch keine Rezepte heruntergeladen. Verbinde dich einmal, dann sind sie auch offline verfügbar.',
    end: 'Das war’s!',
    backToTop: 'Nach oben',
  },
  tags: {
    breakfast: 'Frühstück',
    brunch: 'Brunch',
    lunch: 'Mittagessen',
    dinner: 'Abendessen',
    vegetarian: 'Vegetarisch',
    vegan: 'Vegan',
    'gluten-free': 'Glutenfrei',
  },
  rating: {
    none: 'Noch keine Bewertungen',
    label_one: 'Mit {{rating}} von 5 bewertet von {{count}} Person',
    label_other: 'Mit {{rating}} von 5 bewertet von {{count}} Personen',
    rateStars_one: 'Mit {{count}} Stern bewerten',
    rateStars_other: 'Mit {{count}} Sternen bewerten',
  },
  cart: {
    add: 'Zur Einkaufsliste hinzufügen',
    remove: 'Von der Einkaufsliste entfernen',
    added: 'Zur Einkaufsliste hinzugefügt',
    removed: 'Von der Einkaufsliste entfernt',
    view: 'Ansehen',
  },
  badge: {
    draft: 'Entwurf',
    private: 'Privat',
  },
  recipe: {
    by: 'von {{name}}',
    servings_one: '{{count}} Portion',
    servings_other: '{{count}} Portionen',
    fewerServings: 'Weniger Portionen',
    moreServings: 'Mehr Portionen',
    units: 'Einheiten',
    metric: 'Metrisch',
    imperial: 'Imperial',
    ingredients: 'Zutaten',
    noIngredients: 'Keine Zutaten angegeben.',
    method: 'Zubereitung',
    startCooking: 'Kochen starten',
    continueCooking: 'Weiter bei Schritt {{step}}',
    stepOf: 'Schritt {{current}} von {{total}}',
    next: 'Nächster Schritt',
    finish: 'Fertig',
    returnToCurrent: 'Zurück zum aktuellen Schritt',
    progress: 'Fortschritt im Rezept',
    goToStep: 'Zu Schritt {{step}}',
    stepDone: 'Schritt erledigt',
    startOver: 'Von vorn beginnen',
    finishedTitle: 'Guten Appetit!',
    finishedBody: 'Wie ist es geworden?',
    rateThis: 'Bewerte dieses Rezept',
    yourRating: 'Deine Bewertung',
    ownRecipe: 'Das ist dein Rezept, deshalb kannst du es nicht bewerten.',
    reviews: 'Bewertungen',
    noReviews: 'Noch keine Kommentare.',
    loadMore: 'Mehr anzeigen',
    favourite: 'Zu Favoriten hinzufügen',
    unfavourite: 'Aus Favoriten entfernen',
    favourited: 'Zu Favoriten hinzugefügt',
    unfavourited: 'Aus Favoriten entfernt',
    saveToList: 'In Liste speichern',
    newListPlaceholder: 'Name der neuen Liste',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    deleteTitle: 'Dieses Rezept löschen?',
    deleteBody: 'Es wird für alle entfernt. Das kann nicht rückgängig gemacht werden.',
    deleted: 'Rezept gelöscht',
    draftNotice: 'Das ist ein Entwurf. Nur du kannst ihn sehen.',
    privateNotice: 'Dieses Rezept ist privat. Nur du kannst es sehen.',
    notFound: 'Rezept nicht gefunden',
    notFoundBody: 'Es wurde möglicherweise gelöscht oder auf privat gestellt.',
    notDownloaded: 'Dieses Rezept wurde noch nicht heruntergeladen. Verbinde dich mit dem Internet, um es zu öffnen. Danach funktioniert es auch offline.',
    addThese: 'Folgendes hinzufügen:',
    notes: 'Hinweise',
    photo: 'Foto {{n}} von {{total}}',
    startTimer: 'Timer für {{duration}} starten',
    timerRunning: 'Timer läuft',
  },
  steps: {
    add_ingredients: 'Zutaten hinzufügen',
    cook: 'Garen',
    prep: 'Vorbereiten',
  },
  heat: {
    low: 'Niedrige Hitze',
    medium_low: 'Mittelniedrige Hitze',
    medium: 'Mittlere Hitze',
    medium_high: 'Mittelhohe Hitze',
    high: 'Hohe Hitze',
  },
  method: {
    pan: 'Pfanne',
    pot: 'Topf',
    oven: 'Backofen',
    grill: 'Grill',
    bbq: 'Barbecue',
    steamer: 'Dampfgarer',
    deep_fryer: 'Fritteuse',
    air_fryer: 'Heißluftfritteuse',
    microwave: 'Mikrowelle',
    slow_cooker: 'Schongarer',
    pressure_cooker: 'Schnellkochtopf',
    other: 'Sonstiges',
  },
  review: {
    title: 'Danke für deine Bewertung!',
    saved: 'Bewertung gespeichert',
    commentLabel: 'Kommentar hinzufügen (optional)',
    commentPlaceholder: 'Wie fandest du es? Hast du etwas geändert?',
    post: 'Kommentar veröffentlichen',
    skip: 'Nein danke',
    editComment: 'Kommentar bearbeiten',
    remove: 'Meine Bewertung entfernen',
    removed: 'Bewertung entfernt',
  },
  lists: {
    title: 'Meine Listen',
    shopping: 'Einkaufsliste',
    favourites: 'Favoriten',
    new: 'Neue Liste',
    namePlaceholder: 'z. B. Abendessen unter der Woche',
    rename: 'Liste umbenennen',
    delete: 'Liste löschen',
    deleteTitle: '„{{name}}“ löschen?',
    deleteBody: 'Die Rezepte selbst werden nicht gelöscht.',
    empty: 'Diese Liste ist leer.',
    emptyShopping: 'Tippe bei einem Rezept auf den Korb, um seine Zutaten hier hinzuzufügen.',
    emptyOther: 'Speichere Rezepte über die jeweilige Rezeptseite in dieser Liste.',
    browse: 'Rezepte ansehen',
    recipes_one: '{{count}} Rezept',
    recipes_other: '{{count}} Rezepte',
    consolidate: 'Zutaten zusammenfassen',
    consolidateHint: 'Eine Liste für alles. Eingeklappte Rezepte werden nicht berücksichtigt.',
    collapsedExcluded_one: '{{count}} eingeklapptes Rezept ist nicht enthalten.',
    collapsedExcluded_other: '{{count}} eingeklappte Rezepte sind nicht enthalten.',
    nothingToCombine: 'Klappe ein Rezept auf, um seine Zutaten aufzunehmen.',
    expand: 'Zutaten anzeigen',
    collapse: 'Zutaten ausblenden (für später)',
    remove: 'Aus der Liste entfernen',
    removed: '„{{name}}“ entfernt',
    export: 'Exportieren',
    copy: 'In die Zwischenablage kopieren',
    copied: 'Kopiert! Füge sie in Notizen oder eine andere App ein.',
    copyFailed: 'Die Liste konnte nicht kopiert werden.',
    share: 'Teilen …',
    unavailable: 'Dieses Rezept ist nicht mehr verfügbar.',
    uncheckAll: 'Alle Haken entfernen',
    progress: '{{done}} von {{total}} abgehakt',
  },
  myRecipes: {
    title: 'Meine Rezepte',
    drafts: 'Entwürfe',
    private: 'Privat',
    public: 'Öffentlich',
    emptyDrafts: 'Keine Entwürfe. Rezepte, die du beginnst, werden hier automatisch gespeichert.',
    emptyPrivate: 'Keine privaten Rezepte.',
    emptyPublic: 'Du hast noch keine Rezepte veröffentlicht.',
    untitled: 'Rezept ohne Titel',
    edited: 'Bearbeitet am {{date}}',
  },
  newRecipe: {
    title: 'Rezept hinzufügen',
    subtitle: 'Wie möchtest du anfangen?',
    photoTitle: 'Papierrezept fotografieren',
    photoBody: 'Fotografiere eine Rezeptkarte oder eine Kochbuchseite und die KI macht daraus ein Dishly-Rezept.',
    describeTitle: 'Beschreib oder sag es',
    describeBody: 'Schreib oder sag, was du hast, etwa „Hähnchen, Kartoffeln, Blumenkohl und normale Küchengewürze“, und die KI erstellt ein Rezept.',
    manualTitle: 'Selbst schreiben',
    manualBody: 'Füge dein Rezept Schritt für Schritt hinzu. Deine Arbeit wird laufend gespeichert.',
    comingSoon: 'Demnächst',
    comingSoonBody: 'Das Erstellen von Rezepten mit KI ist noch nicht verfügbar. Bis dahin kannst du das Rezept selbst schreiben.',
    choosePhoto: 'Foto aufnehmen oder auswählen',
    describePlaceholder: 'Ich habe Hähnchen, Kartoffeln, Blumenkohl und normale Küchengewürze …',
    generate: 'Rezept erstellen',
    writeManually: 'Selbst schreiben',
    drafts: 'Entwurf fortsetzen',
    addPage: 'Weitere Seite hinzufügen',
    photoHint: 'Bis zu {{count}} Fotos, etwa beide Seiten eines Kochbuchs.',
    noteLabel: 'Noch etwas? (optional)',
    notePlaceholder: 'z. B. „Für 6 Personen“ oder „Im Ofen statt auf dem Grill“',
    voiceHint: 'Oder tippe aufs Mikrofon und sag es.',
    working: 'Dein Rezept wird geschrieben …',
    workingPhotos: 'Deine Fotos werden gelesen …',
    linkTitle: 'Link einfügen',
    linkBody: 'Ein Rezept im Netz gefunden? Füge den Link ein und die KI holt es samt Foto in Dishly.',
    linkLabel: 'Link zum Rezept',
    linkHint: 'Klappt mit den meisten Rezeptseiten. Die Website wird im Rezept genannt, und du kannst alles prüfen, bevor du es veröffentlichst.',
    workingLink: 'Die Seite wird gelesen …',
    workingHint: 'Das kann bis zu einer Minute dauern. Lass diese Seite geöffnet.',
  },
  save: {
    button: 'In Dishly speichern',
    title: 'In Dishly speichern',
    dragHint: 'Zieh diesen Button in deine Lesezeichenleiste und klick ihn auf einer Rezeptseite an.',
    tip: 'Speichere Rezepte direkt aus deinem Browser: Zieh diesen Button in deine Lesezeichenleiste und klick ihn auf einer Rezeptseite an.',
    setUp: 'Zieh diesen Button in deine Lesezeichenleiste. Klick ihn dann auf einer beliebigen Rezeptseite an, um das Rezept in Dishly zu holen.',
    howTo: 'Diese Seite öffnet sich, wenn du auf einer Rezeptseite in deiner Lesezeichenleiste auf „In Dishly speichern“ klickst. Auf dem Handy füg stattdessen den Link zum Rezept ein oder mach Screenshots.',
    popupBlocked: 'Erlaube Pop-ups auf dieser Website, um das Rezept in Dishly zu speichern.',
    waiting: 'Die Rezeptseite wird abgerufen …',
    nothing: 'Von der Rezeptseite ist nichts angekommen',
    nothingHint: 'Geh zurück zur Rezeptseite und klick noch einmal auf „In Dishly speichern“.',
    confirm: 'Dieses Rezept von {{site}} in Dishly holen? Die KI schreibt es als Entwurf, den du prüfen kannst.',
    import: 'Rezept importieren',
    blocked: '{{site}} lässt Apps seine Rezepte nicht lesen.',
    blockedDesktop: 'Du kannst es trotzdem aus deinem Browser speichern: Zieh den Button unten in deine Lesezeichenleiste, öffne das Rezept und klick auf das Lesezeichen. Oder mach Screenshots und nutze „Papierrezept fotografieren“.',
    blockedMobile: 'Mach Screenshots vom Rezept (bis zu 4) und nutze stattdessen „Papierrezept fotografieren“.',
  },
  voice: {
    start: 'Sprachaufnahme starten',
    stop: 'Aufnahme beenden',
    say: 'Sprechen',
    transcribing: 'Wird transkribiert …',
    denied: 'Der Zugriff aufs Mikrofon ist blockiert. Erlaube ihn in den Browsereinstellungen, um deine Stimme zu nutzen.',
    unavailable: 'Das Mikrofon konnte nicht gestartet werden.',
    nothingHeard: 'Das haben wir nicht verstanden. Bitte versuch es noch einmal.',
  },
  adapt: {
    open: 'Fragen oder anpassen',
    title: 'Frage stellen oder Rezept anpassen',
    intro: 'Stell eine Frage, etwa „Mein Ofen hat keinen Grill, was kann ich stattdessen nehmen?“, oder sag, was sich ändern soll, etwa „Ich habe keine Fischsauce“. Änderungen gelten nur für dich.',
    placeholder: 'Stell eine Frage oder sag, was sich ändern soll …',
    submit: 'Senden',
    working: 'Einen Moment …',
    you: 'Du',
    changed: 'Rezept angepasst',
    noChange: 'Es wurde nichts geändert.',
    noticeTitle: 'Für dich angepasst',
    noticeBody: 'Nur du siehst diese Version. Das Originalrezept bleibt, wie es ist.',
    changedStep: 'Geändert',
    saveCopy: 'Als meine Kopie speichern',
    copySaved: 'In deinen Rezepten gespeichert',
    adaptedFrom: 'Angepasst nach [{{name}}]({{path}}) von {{author}}.',
    apply: 'Ins Rezept übernehmen',
    applyTitle: 'Dein Rezept mit diesen Änderungen aktualisieren?',
    applyBody: 'Alle, die dieses Rezept sehen können, sehen dann die geänderte Version.',
    applied: 'Rezept aktualisiert',
    applyInvalid: 'Dem geänderten Rezept fehlt etwas. Speichere es als Kopie oder bearbeite das Rezept.',
    discard: 'Zurück zum Original',
  },
  editor: {
    newTitle: 'Neues Rezept',
    editTitle: 'Rezept bearbeiten',
    name: 'Rezeptname',
    namePlaceholder: 'z. B. Omas Apfelcrumble',
    photos: 'Fotos',
    photosHint: 'Das erste Foto ist das Titelbild.',
    addPhotos: 'Fotos hinzufügen',
    uploading: 'Wird hochgeladen …',
    cover: 'Titelbild',
    makeCover: 'Als Titelbild verwenden',
    removePhoto: 'Foto entfernen',
    uploadFailed: 'Hochladen fehlgeschlagen: {{message}}',
    tooManyPhotos: 'Du kannst bis zu {{count}} Fotos hinzufügen.',
    description: 'Über dieses Rezept',
    descriptionPlaceholder: 'Die Geschichte dahinter, Tipps, wozu man es serviert …',
    write: 'Schreiben',
    preview: 'Vorschau',
    markdownHint: 'Markdown wird unterstützt: **fett**, *kursiv*, Listen und Links.',
    nothingToPreview: 'Noch nichts für die Vorschau.',
    details: 'Details',
    totalTime: 'Gesamtzeit (Minuten)',
    stepTotal: 'Die Schritte mit Zeitangabe ergeben {{duration}}.',
    useStepTotal: 'Übernehmen',
    servings: 'Portionen',
    tags: 'Schlagwörter',
    steps: 'Schritte',
    stepsHint: 'Beim Kochen sieht man immer einen Schritt auf einmal.',
    noSteps: 'Noch keine Schritte. Füge unten den ersten hinzu.',
    addStep: 'Schritt hinzufügen',
    stepTypeHelp: {
      add_ingredients: 'Eine oder mehrere Zutaten mit Mengen',
      cook: 'Mit Hitze: anbraten, backen, köcheln …',
      prep: 'Schneiden, mischen, ruhen lassen, Blech auslegen …',
    },
    stepNumber: 'Schritt {{n}}',
    stepType: 'Art des Schritts',
    instruction: 'Anleitung',
    instructionOptional: 'Anleitung (optional)',
    instructionPlaceholder: {
      add_ingredients: 'z. B. In einer großen Schüssel verquirlen',
      cook: 'z. B. Anbraten, bis alles weich und goldbraun ist',
      prep: 'z. B. Die Tomaten würfeln',
    },
    ingredients: 'Zutaten',
    addIngredient: 'Zutat hinzufügen',
    ingredient: 'Zutat',
    ingredientPlaceholder: 'z. B. Olivenöl',
    quantity: 'Menge',
    quantityPlaceholder: 'z. B. 1½',
    unit: 'Einheit',
    unitNone: 'Stück / ohne Einheit',
    note: 'Hinweis',
    notePlaceholder: 'z. B. fein gehackt',
    removeIngredient: 'Zutat entfernen',
    equipment: 'Gerät',
    heat: 'Hitze',
    notSpecified: 'Keine Angabe',
    temperature: 'Temperatur (°{{unit}})',
    duration: 'Zeit (Minuten)',
    durationHint: 'Fügt diesem Schritt einen Timer hinzu.',
    notes: 'Hinweise',
    addNotes: 'Hinweise hinzufügen',
    notesPlaceholder: 'Tipps oder Details zu diesem Schritt',
    stepPhotos: 'Fotos zum Schritt',
    addStepPhotos: 'Fotos hinzufügen',
    moveUp: 'Schritt nach oben',
    moveDown: 'Schritt nach unten',
    deleteStep: 'Schritt löschen',
    dragStep: 'Zum Sortieren ziehen',
    overview: 'Zutatenübersicht',
    overviewHint: 'Wird automatisch aus deinen Schritten „Zutaten hinzufügen“ erstellt.',
    overviewEmpty: 'Zutaten aus deinen Schritten erscheinen hier.',
    save: 'Rezept speichern',
    saveTitle: 'Rezept speichern',
    saveBody: 'Wer soll es sehen können?',
    public: 'Öffentlich',
    publicHint: 'Teile es mit allen auf Dishly.',
    private: 'Privat',
    privateHint: 'Nur du kannst es sehen. Du kannst es später veröffentlichen.',
    recommended: 'Empfohlen',
    published: 'Rezept veröffentlicht!',
    savedPrivate: 'In deinen privaten Rezepten gespeichert.',
    status: {
      saving: 'Wird gespeichert …',
      saved: 'Entwurf gespeichert',
      local: 'Auf diesem Gerät gespeichert',
      offline: 'Offline: auf diesem Gerät gespeichert',
      error: 'Speichern fehlgeschlagen',
    },
    fixErrors: 'Bitte korrigiere die markierten Felder.',
    errors: {
      required: 'Pflichtfeld',
      number: 'Gib eine Zahl ein',
      name: 'Gib deinem Rezept einen Namen',
      steps: 'Füge mindestens einen Schritt hinzu',
      instruction: 'Beschreibe diesen Schritt',
      ingredients: 'Füge mindestens eine Zutat hinzu',
      ingredientName: 'Gib die Zutat ein',
    },
    deleteDraft: 'Entwurf löschen',
    deleteDraftTitle: 'Diesen Entwurf löschen?',
    deleteDraftBody: 'Das kann nicht rückgängig gemacht werden.',
    restoreTitle: 'Ungespeicherte Änderungen gefunden',
    restoreBody: 'Du hast Änderungen an diesem Rezept vom {{date}}, die nicht gespeichert wurden.',
    aiTitle: 'Von der KI geschrieben',
    aiBody: 'Prüfe Zutaten, Mengen und Schritte und speichere dann. Vorher wird nichts veröffentlicht.',
    restore: 'Wiederherstellen',
    discard: 'Verwerfen',
    offlineUnavailable: 'Dieses Rezept ist nicht heruntergeladen. Verbinde dich mit dem Internet, um es zu bearbeiten.',
    notYours: 'Du kannst nur deine eigenen Rezepte bearbeiten.',
  },
  auth: {
    title: 'Willkommen bei Dishly',
    loginTab: 'Anmelden',
    signupTab: 'Registrieren',
    email: 'E-Mail',
    password: 'Passwort',
    displayName: 'Anzeigename',
    displayNameHint: 'Wird bei deinen Rezepten und Bewertungen angezeigt.',
    passwordHint: 'Mindestens 8 Zeichen.',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
    forgot: 'Passwort vergessen?',
    logIn: 'Anmelden',
    createAccount: 'Konto erstellen',
    loginToContinue: 'Melde dich an oder erstelle ein Konto, um fortzufahren.',
    welcomeBack: 'Willkommen zurück, {{name}}!',
    checkEmailTitle: 'Sieh in dein Postfach',
    checkEmailBody: 'Wir haben einen Link an {{email}} geschickt. Klicke darauf, um deine Adresse zu bestätigen, und melde dich dann an.',
    resend: 'E-Mail erneut senden',
    resent: 'Gesendet! Sieh in deinen Posteingang (und Spam-Ordner).',
    backToLogin: 'Zurück zur Anmeldung',
    notVerified: 'Bitte bestätige zuerst deine E-Mail-Adresse. Den Link findest du in deinem Posteingang.',
    recaptcha: 'Geschützt durch reCAPTCHA: Es gelten die <privacy>Datenschutzerklärung</privacy> und die <terms>Nutzungsbedingungen</terms> von Google.',
    verifyTitle: 'E-Mail-Adresse bestätigen',
    verifying: 'Deine E-Mail-Adresse wird bestätigt …',
    verified: 'E-Mail-Adresse bestätigt!',
    verifiedBody: 'Du kannst dich jetzt bei Dishly anmelden.',
    verifyFailed: 'Deine E-Mail-Adresse konnte nicht bestätigt werden.',
    verifyExpired: 'Dieser Link ist abgelaufen. Gib deine E-Mail-Adresse ein, um einen neuen zu erhalten.',
    forgotTitle: 'Passwort zurücksetzen',
    forgotBody: 'Gib deine E-Mail-Adresse ein. Wir schicken dir einen Link, um ein neues Passwort zu wählen.',
    sendLink: 'Link senden',
    linkSent: 'Falls es ein Konto für {{email}} gibt, ist ein Link unterwegs.',
    resetTitle: 'Neues Passwort wählen',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Neues Passwort bestätigen',
    passwordsDontMatch: 'Die Passwörter stimmen nicht überein.',
    savePassword: 'Passwort speichern',
    passwordUpdated: 'Passwort geändert. Du kannst dich jetzt anmelden.',
    resetInvalid: 'Dieser Link ist ungültig oder abgelaufen.',
    requestNew: 'Neuen Link anfordern',
  },
  account: {
    title: 'Konto',
    profile: 'Profil',
    displayName: 'Anzeigename',
    email: 'E-Mail',
    memberSince: 'Mitglied seit {{date}}',
    saved: 'Gespeichert',
    preferences: 'Einstellungen',
    units: 'Bevorzugte Einheiten',
    metric: 'Metrisch (g, ml, °C)',
    imperial: 'Imperial (oz, Tassen, °F)',
    language: 'Standardsprache',
    theme: 'Design',
    themeSystem: 'System',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    security: 'Passwort',
    resetPassword: 'Passwort zurücksetzen',
    resetHint: 'Wir schicken dir per E-Mail einen Link, um ein neues Passwort zu wählen.',
    resetSent: 'Den Link zum Zurücksetzen findest du in deinem Postfach.',
    logOut: 'Abmelden',
  },
  timers: {
    title: 'Timer',
    done: 'Fertig!',
    pause: 'Timer pausieren',
    resume: 'Timer fortsetzen',
    cancel: 'Timer abbrechen',
    dismiss: 'Schließen',
    started: 'Timer gestartet: {{duration}}',
    notificationTitle: 'Timer abgelaufen',
    goToStep: 'Zum Schritt',
  },
  pwa: {
    updateAvailable: 'Eine neue Version von Dishly ist verfügbar.',
    update: 'Aktualisieren',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    body: 'Wir konnten nicht finden, wonach du gesucht hast.',
    home: 'Zu den Rezepten',
  },
  errors: {
    generic: 'Etwas ist schiefgelaufen. Bitte versuch es erneut.',
    network: 'Du bist offline oder der Server ist nicht erreichbar.',
    codes: {
      invalid_credentials: 'E-Mail-Adresse oder Passwort sind nicht korrekt.',
      email_not_verified: 'Bitte bestätige zuerst deine E-Mail-Adresse.',
      rate_limited: 'Zu viele Versuche. Bitte warte ein paar Minuten und versuch es erneut.',
      captcha_required: 'Bitte schließe die Captcha-Prüfung ab.',
      captcha_failed: 'Die Captcha-Prüfung ist fehlgeschlagen. Bitte versuch es erneut.',
      captcha_unavailable: 'Das Captcha konnte nicht geprüft werden. Bitte versuch es erneut.',
      token_expired: 'Dieser Link ist abgelaufen.',
      token_invalid: 'Dieser Link ist ungültig oder wurde bereits verwendet.',
      email_failed: 'Die E-Mail konnte nicht gesendet werden. Bitte versuch es gleich noch einmal.',
      too_large: 'Das ist zu groß.',
      unsupported_image: 'Bitte lade ein JPEG-, PNG-, WebP-, GIF- oder AVIF-Bild hoch.',
      invalid_image: 'Dieses Bild konnte nicht verarbeitet werden.',
      too_many_lists: 'Du hast die maximale Anzahl an Listen erreicht.',
      own_recipe: 'Du kannst dein eigenes Rezept nicht bewerten.',
      not_found: 'Nicht gefunden.',
      forbidden: 'Dazu fehlt dir die Berechtigung.',
      unauthorized: 'Bitte melde dich an, um fortzufahren.',
      validation_error: 'Einige Felder sind ungültig.',
      invalid_recipe: 'Bitte korrigiere die markierten Felder.',
      builtin_list: 'Standardlisten können nicht geändert werden.',
      server_error: 'Bei uns ist etwas schiefgelaufen.',
      ai_disabled: 'KI-Funktionen sind gerade nicht verfügbar.',
      ai_unavailable: 'Der KI-Dienst antwortet nicht. Bitte versuch es gleich noch einmal.',
      ai_failed: 'Die KI konnte nicht fertig werden. Bitte versuch es noch einmal.',
      ai_refused: 'Bei dieser Anfrage kann die KI nicht helfen.',
      unsupported_audio: 'Dieses Aufnahmeformat wird nicht unterstützt.',
      invalid_url: 'Das sieht nicht nach einer Webadresse aus.',
      page_unreachable: 'Die Seite konnte nicht geöffnet werden. Prüf den Link und versuch es noch einmal.',
      page_blocked: 'Diese Website lässt Apps ihre Rezepte nicht lesen. Mach einen Screenshot und nutze „Papierrezept fotografieren“.',
      not_a_page: 'Dieser Link ist keine Webseite.',
    },
  },
  time: {
    seconds_one: '{{count}} Sek.',
    seconds_other: '{{count}} Sek.',
    minutes_one: '{{count}} Min.',
    minutes_other: '{{count}} Min.',
    hours_one: '{{count}} Std.',
    hours_other: '{{count}} Std.',
    hoursMinutes: '{{hours}} Std. {{minutes}} Min.',
  },
  units: {
    g: 'g',
    kg: 'kg',
    oz: 'oz',
    lb: 'lb',
    ml: 'ml',
    l: 'l',
    tsp: 'TL',
    tbsp: 'EL',
    cup_one: 'Tasse',
    cup_other: 'Tassen',
    fl_oz: 'fl oz',
    pint_one: 'Pint',
    pint_other: 'Pints',
    pinch_one: 'Prise',
    pinch_other: 'Prisen',
    clove_one: 'Zehe',
    clove_other: 'Zehen',
    slice_one: 'Scheibe',
    slice_other: 'Scheiben',
    can_one: 'Dose',
    can_other: 'Dosen',
    bunch_one: 'Bund',
    bunch_other: 'Bund',
    sprig_one: 'Zweig',
    sprig_other: 'Zweige',
    handful_one: 'Handvoll',
    handful_other: 'Handvoll',
    package_one: 'Packung',
    package_other: 'Packungen',
  },
  unitNames: {
    g: 'Gramm (g)',
    kg: 'Kilogramm (kg)',
    oz: 'Unzen (oz)',
    lb: 'Pfund (lb)',
    ml: 'Milliliter (ml)',
    l: 'Liter (l)',
    tsp: 'Teelöffel (TL)',
    tbsp: 'Esslöffel (EL)',
    cup: 'Tassen',
    fl_oz: 'Flüssigunzen (fl oz)',
    pint: 'Pints',
    pinch: 'Prise',
    clove: 'Zehen',
    slice: 'Scheiben',
    can: 'Dosen',
    bunch: 'Bund',
    sprig: 'Zweige',
    handful: 'Handvoll',
    package: 'Packungen',
  },
  unitGroups: {
    mass: 'Gewicht',
    volume: 'Volumen',
    other: 'Sonstige',
  },
};

export default de;
